export const PURCHASE_ACCOUNT_PATH = '/purchase/account';

export const isPurchaseAccountPage = (pathname: string): boolean => pathname === PURCHASE_ACCOUNT_PATH;
